import type { AboutContent } from "../../domain/entities/AboutContent";
import type { AboutRepository } from "../../domain/repositories/AboutRepository";
import { aboutContentData } from "../data/aboutContent";

export class AboutRepositoryImpl implements AboutRepository {
  async getContent(): Promise<AboutContent> {
    return aboutContentData;
  }
}
